var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from '../avatar/avatar';
import { CameraIcon } from '@heroicons/react/solid';
import * as styles from './profile-avatar.styles';
import { classNames } from '../../utils/style-class.utils';
import UserAvatar from '../user-avatar/user-avatar';
export var ProfileAvatar = function (_a) {
    var dataUrl = _a.dataUrl, size = _a.size, _b = _a.userAvatarText, userAvatarText = _b === void 0 ? '' : _b, className = _a.className, _c = _a.hasConsent, hasConsent = _c === void 0 ? false : _c, _d = _a.canChangeImage, canChangeImage = _d === void 0 ? true : _d, onPressed = _a.onPressed;
    var displayAvatar = hasConsent && !!dataUrl;
    var displayUserAvatar = !hasConsent || (hasConsent && !dataUrl);
    return (_jsxs("a", __assign({ className: classNames(styles.wrapper, className), onClick: onPressed }, { children: [displayAvatar && (_jsx(Avatar, { size: size, dataUrl: dataUrl, displayBorder: true })), displayUserAvatar && (_jsx(UserAvatar, { size: size, color: 'secondary', text: userAvatarText, displayBorder: true, borderColour: 'white' })), canChangeImage && (_jsx("div", __assign({ className: styles.camaraWrapper, "data-testid": "profile-icon-wrapper" }, { children: _jsx(CameraIcon, { style: styles.getCameraIconSize(size), className: styles.iconColor }) })))] })));
};
export default ProfileAvatar;
//# sourceMappingURL=profile-avatar.js.map